module.exports = __webpack_public_path__ + "img/大数据OPSbanner.3e07d80f.png";